<template>
  <div class="container">

    <div class="row">
      <div class="col-12">
        <h1>Beynəlxalq və ölkədaxili sərnişindaşıma xidmətləri</h1>
      </div>
    </div>

    <div class="row block">

      <div class="col-md-6">
         <p>Bakı Beynəlxalq Avtovağzal kompleksində ölkədaxili şəhərlərə sərnişin biletlərinin satış qiymətləri: </p>
        <input type="text" v-model="internalQuery" placeholder="axtar">

        <table>
          <thead>
            <tr>
              <th>Marşrut</th>
              <th>Qiymət</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="direction in filteredInternalDirections">
              <td>{{ direction.name }}</td>
              <td><strong>{{ direction.price }}</strong> AZN</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-md-6">
         <p>Bakı Beynəlxalq Avtovağzal kompleksində beynəlxalq marşrutlarda işləyən avtobuslarda gediş haqqı tarifləri: </p>
        <input type="text" v-model="externalQuery" placeholder="axtar">
        <table>
          <thead>
            <tr>
              <th>Marşrut</th>
              <th>Qiymət</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="direction in filteredExternalDirections">
              <td>{{ direction.name }}</td>
              <td><strong>{{ direction.price }}</strong> AZN</td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>

  </div>
</template>

<script> 
  export default {
    data(){
      return {
        internalQuery: '',
        externalQuery: '',
        internalDirections: [
			{"name":"Ağcabədi", "distance":"285", "price":"10,5"},
			{"name":"Ağdam (Mahrızlı)", "distance":"365", "price":"13,5"},
			{"name":"Ağdam (Qaradağlı)", "distance":"364", "price":"13,5"},
			{"name":"Ağdam (Quzanlı)", "distance":"341", "price":"12,6"},
			{"name":"Ağdaş", "distance":"277", "price":"10,3"},
			{"name":"Ağsu", "distance":"153", "price":"5,7"},
			{"name":"Astara", "distance":"281", "price":"10,4"},
			{"name":"Bakı-Ağdam", "distance":"351", "price":"23"},
			{"name":"Bakı-Füzuli", "distance":"306", "price":"18,4"},
			{"name":"Bakı-Şuşa", "distance":"387", "price":"25,4"},
			{"name":"Balakən", "distance":"449", "price":"16,6"},
			{"name":"Balakən (Qabaqçöl)", "distance":"467", "price":"17,3"},
			{"name":"Beyləqan", "distance":"270", "price":"10"},
			{"name":"Bərdə", "distance":"313", "price":"11,6"},
			{"name":"Biləsuvar", "distance":"177", "price":"6,5"},
			{"name":"Cəlilabad", "distance":"193", "price":"7,1"},
			{"name":"Füzuli (Əhmədbəyli)", "distance":"295", "price":"10,9"},
			{"name":"Füzuli (Horadiz)", "distance":"291", "price":"10,8"},
			{"name":"Gədəbəy", "distance":"447", "price":"16,5"},
			{"name":"Gədəbəy (Çayrəsullu)", "distance":"488", "price":"18,1"},
			{"name":"Gədəbəy (İsalı)", "distance":"479", "price":"17,7"},
			{"name":"Gədəbəy (Novoivanovka)", "distance":"486", "price":"18"},
			{"name":"Gədəbəy (Novosaratovka)", "distance":"475", "price":"17,6"},
			{"name":"Gədəbəy (Qoşabulaq)", "distance":"462", "price":"17,1"},
			{"name":"Gəncə", "distance":"353", "price":"13,1"},
			{"name":"Goranboy", "distance":"313", "price":"9,4"},
			{"name":"Goranboy (Ağcakənd)", "distance":"349", "price":"10,5"},
			{"name":"Göyçay", "distance":"249", "price":"9,2"},
			{"name":"Göygöl", "distance":"365", "price":"13,5"},
			{"name":"İmişli", "distance":"220", "price":"8,1"},
			{"name":"İsmayıllı", "distance":"267", "price":"9,9"},
			{"name":"İsmayıllı (Hacıhətəmli)", "distance":"234", "price":"7"},
			{"name":"Kürdəmir", "distance":"193", "price":"7,1"},
			{"name":"Lənkəran", "distance":"239", "price":"8,8"},
			{"name":"Masallı", "distance":"213", "price":"7,9"},
			{"name":"Mingəçevir", "distance":"309", "price":"11,4"},
			{"name":"Naftalan", "distance":"330", "price":"12,2"},
			{"name":"Oğuz", "distance":"355", "price":"13,1"},
			{"name":"Oğuz (Xaçmaz)", "distance":"333", "price":"10"},
			{"name":"Qax", "distance":"394", "price":"14,6"},
			{"name":"Qazax", "distance":"477", "price":"17,6"},
			{"name":"Qazax (Kəmərli)", "distance":"515", "price":"19,1"},
			{"name":"Qazax (Sadıxlı)", "distance":"500", "price":"18,5"},
			{"name":"Qəbələ", "distance":"310", "price":"11,5"},
			{"name":"Qırmızı Körpü", "distance":"516", "price":"19,1"},
			{"name":"Quba", "distance":"159", "price":"5,9"},
			{"name":"Qusar", "distance":"174", "price":"6,4"},
			{"name":"Qusar (Həzrə)", "distance":"235", "price":"8,7"},
			{"name":"Qusar (SDK)", "distance":"196", "price":"7,3"},
			{"name":"Saatlı", "distance":"191", "price":"7,1"},
			{"name":"Sabirabad", "distance":"166", "price":"6,1"},
			{"name":"Şabran", "distance":"116", "price":"4,3"},
			{"name":"Şamaxı", "distance":"116", "price":"4,3"},
			{"name":"Şəki", "distance":"356", "price":"13,2"},
			{"name":"Şəmkir", "distance":"406", "price":"15"},
			{"name":"Siyəzən", "distance":"97", "price":"3,6"},
			{"name":"Tərtər", "distance":"329", "price":"12,2"},
			{"name":"Tovuz", "distance":"444", "price":"16,4"},
			{"name":"Tovuz (Böyük Qışlaq)", "distance":"463", "price":"17,1"},
			{"name":"Ucar", "distance":"241", "price":"8,9"},
			{"name":"Xaçmaz", "distance":"149", "price":"5,5"},
			{"name":"Xaçmaz (Nabran)", "distance":"195", "price":"7,2"},
			{"name":"Xaçmaz (Yalama)", "distance":"200", "price":"7,4"},
			{"name":"Xudat", "distance":"171", "price":"6,3"},
			{"name":"Zaqatala", "distance":"421", "price":"15,6"},
			{"name":"Zərdab", "distance":"252", "price":"9,3"}
        ],
        externalDirections: [
          {"name":"İstanbul", "price":"100"},
          {"name":"Kazan", "price":"100"},
          {"name":"Krasnodar", "price":"83"},
          {"name":"Laqodexi", "price":"15"},
          {"name":"Marneuli", "price":"16"},
          {"name":"Moskva", "price":"100"},
          {"name":"Naxçıvan", "price":"30"},
          {"name":"Nijniy Novqorod", "price":"110"},
          {"name":"Quş adası(Türkiyə)", "price":"150"},
          {"name":"Samara", "price":"90"},
          {"name":"Sankt Peterburq", "price":"120"},
          {"name":"Stavropol", "price":"46,89"},
          {"name":"Sverdlovsk", "price":"150"},
          {"name":"Tbilisi", "price":"17"},
          {"name":"Tehran", "price":"40"},
          {"name":"Təbriz", "price":"30"},
          {"name":"Tolyatti", "price":"90"}
        ]
      }
    },
    computed: {
      filteredInternalDirections: function() {
        let query = this.internalQuery;
        return this.internalDirections.filter(function(dir) {
          return ( dir.name.toLowerCase().indexOf(query.toLowerCase()) !== -1 );
        });
      },
      filteredExternalDirections: function() {
        let query = this.externalQuery;
        return this.externalDirections.filter(function(dir) {
          return ( dir.name.toLowerCase().indexOf(query.toLowerCase()) !== -1 );
        });
      }
    }
  }
</script>

<style scoped>


</style>


// WEBPACK FOOTER //
// src/components/calc/Bus.vue